import React from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function SimpleSelect(props) {
  const { t } = props;
  const classes = useStyles();
  const [value, setvalue] = React.useState(10);

  const handleChange = (event) => {
    setvalue(event.target.value);
    if(event.target.value != 10){
      props.onOptionChange(event.target.value)
    }
  };

  return (
    <div>
      <FormControl className={classes.formControl}>
       
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          onChange={handleChange}
        >
          <MenuItem value={10}>{t('Please select issue type')}</MenuItem>
          {
            props && props.options && props.options.length > 0 && props.options.map( obj => {
              return  <MenuItem value={obj}>{t(obj)}</MenuItem>
            })
          }
        </Select>
      </FormControl>  
    </div>
  );
}


function mapStateToProps(state) {
  return { 
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : state.storeState.templateID,
    communityuid: state.storeState.communityId,
    componentbgcolor: state.storeState.componentbgcolor 
  };
}

export default connect(mapStateToProps)(withTranslation()(SimpleSelect));
